import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  float: left;
  height: 400px;
  padding: 1rem 1rem 0 0.5rem;

  @media (max-width: 1024px) {
    padding: 0;
  }
`;

export const Description = styled.div`
  width: 100%;
  float: left;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-end;
  background: ${({ theme }) => theme.colors.BG2};
  border: ${({ theme }) => `1px solid ${theme.colors.BORDER}`};
  box-shadow: ${({ theme }) => `1px 5px 5px ${theme.colors.SHADOW}`};
  max-width: 250px;
  border-radius: 8px;
  padding: 0px;

  header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    float: left;
    width: 100%;
    padding: 10px 10px 0 10px;

    h1 {
      width: 36px;
      height: 36px;
      background: ${({ theme }) => theme.colors.BG1};
      border: ${({ theme }) => `1px solid ${theme.colors.BORDER}`};
      box-shadow: ${({ theme }) => `1px 5px 5px ${theme.colors.SHADOW}`};
      border-radius: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 18px;
      float: left;
      margin: 0px;
    }

    i {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 40px;
      height: 40px;
      border-radius: 100%;
      margin: 0px;
      float: left;
    }
  }

  main {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    padding: 10px;

    h2 {
      font-size: 10px;
      font-weight: normal;
      color: ${({ theme }) => theme.colors.TEXT1};
      float: left;
      width: 100%;
    }

    h3 {
      font-size: 12px;
      color: ${({ theme }) => theme.colors.TEXT1};
      margin: 2px 0 5px 0;
      font-weight: 700;
      text-transform: uppercase;
      float: left;
      width: 100%;
    }

    ins {
      float: left;
      width: 100%;
      height: 2px;
      background: ${({ theme }) => theme.colors.LIGHT2};
      margin: 10px 0 10px 0;
    }

    h4 {
      font-size: 10px;
      font-weight: normal;
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      float: left;
      width: 100%;

      b {
        padding-left: 5px;
        color: #9d4817ff;
      }
    }

    h5 {
      font-size: 10px;
      font-weight: normal;
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      float: left;
      width: 100%;

      b {
        padding-left: 5px;
        color: #179d46;
      }
    }
  }

  @media (max-width: 1024px) {
    padding: 0;
    width: 200px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: ${({ theme }) => theme.colors.BG1};
    border: ${({ theme }) => `1px solid ${theme.colors.BORDER}`};
    box-shadow: ${({ theme }) => `1px 5px 5px ${theme.colors.SHADOW}`};
    border-radius: 5px;
    margin-left: -100px;

    i {
      width: 26px;
      height: 26px;
      border: none;
      background: none;
      box-shadow: none;

      svg {
        width: 20px;
      }
    }

    main {
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      

      h1 {
        width: 20px;
        height: 20px;
        font-size: 12px;
      }

      h2 {
        font-size: 10px;
      }

      h3 {
        font-size: 10px;
        width: 100%;
        float: left;
        display: flex;
        flex-wrap: wrap;
        white-space: normal;
      }

      h5 {
        font-size: 10px;
      }

      h4 {
        font-size: 10px;
      }
    }
  }
`;
